exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info-text[data-v-7eb3b9c5]{font-size:1.1rem;padding-right:22rem}@media screen and (max-width:1024px){.info-text[data-v-7eb3b9c5]{padding-right:0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7eb3b9c5","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/components/organisms/request-sections/OrganismRequestSectionInterestedCompanies.vue
// module id = 1288
// module chunks = 0